// @flow

import * as ActionTypes from "./constants";

type UserInfoType = {
  id: string,
  ttl: number,
  created: Date,
  userId: string
};

type InitialStateType = {
  info: UserInfoType,
  notifications: any,
  tickers: Array,
  transactions: Array,
  authorized: boolean,
  details: any,
  error: any,
  removed: boolean,
  loaded: boolean,
  loader: boolean,
  saving: boolean,
  project: any,
  lang: string
};

const initialState = {
  info:        null,
  tickers:     [],
  transactions:     [],
  authorized:  false,
  logging:      false,
  details:     null,
  error:       null,
  loaded:      false,
  loader:      false,
  saving:      false,
  notifications: [],
  experience:  [],
  project: {},
  isOpenAuth: false,
  lang: localStorage.hbcLang?localStorage.hbcLang:"EN"
};

export default function reducer(state: InitialStateType = initialState, action) {
  const { type, data, locale } = action;
  switch (type) {
    case ActionTypes.USER_LOGIN_REQUEST:
      return {
        ...state,
        logging: true
      };
    case ActionTypes.USER_LOGIN_SUCCESS:
      return {
        ...state,
        info:       data,
        authorized: true,
        logging:   false
      };

    case ActionTypes.GET_TICKERS_SUCCESS:
      return {
        ...state,
        tickers: data
      };

    case ActionTypes.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: data
      };

    case ActionTypes.GET_NOTIFICATION_REQUEST:
    case `${ActionTypes.SEND_INVEST}_REQUEST`:
    case ActionTypes.DELETE_INVEST_REQUEST:
    case ActionTypes.CANCEL_WITHDRAW_REQUEST:
    case `${ActionTypes.PERFORM_WITHDRAW}_REQUEST`:
      return {
        ...state,
        loader: true
      };

    case `${ActionTypes.SEND_INVEST}_SUCCESS`:
    case `${ActionTypes.SEND_INVEST}_FAILURE`:
    case ActionTypes.DELETE_INVEST_SUCCESS:
    case ActionTypes.DELETE_INVEST_FAILURE:
    case ActionTypes.CANCEL_WITHDRAW_SUCCESS:
    case ActionTypes.CANCEL_WITHDRAW_FAILURE:
    case `${ActionTypes.PERFORM_WITHDRAW}_SUCCESS`:
    case `${ActionTypes.PERFORM_WITHDRAW}_FAILURE`:
      return {
        ...state,
        loader: false
      };

    case ActionTypes.CLEAR_ERROR_MESSAGE:
      return {
        ...state,
        error: null
      };

    case ActionTypes.USER_ME_SUCCESS:
      return {
        ...state,
        info:       data,
        logging: true,
        authorized: true
      };


    case ActionTypes.USER_LOGIN_FAILURE:
      return {
        ...state,
        error: data.error,
        logging:   false

      };

    case ActionTypes.CLEAR_UNREAD_NOTIFICATIONS:
      return {
        ...state,
        info: Object.assign({}, state.info, data)
      };

    case ActionTypes.SET_LOCALE_REQUEST:
      return {
        ...state,
        lang: locale
      };

    case ActionTypes.USER_LOGOUT_SUCCESS:
      return {
        ...initialState,
        loaded: true,
        lang: state.lang
      };
    case ActionTypes.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: data,
        loader: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/ducks/user/reducer.js